import { FC, ReactNode } from "react";
import { SxProps, Theme } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import GenericDateRange from "@/components/dateTime/genericDateRange";

type AnchorDataOverviewDatePickerProps = {
  value: string | null | undefined;
  onChange: (value: string | null) => void;
  size?: "small" | "medium";
  sx?: SxProps<Theme>;
  className?: string;
  inputRef?: (el: HTMLInputElement | null) => void;
  autoFocus?: boolean;
  onBlur?: () => void;
  onKeyDown?: (event: React.KeyboardEvent) => void;
  startAdornment?: ReactNode;
};

const parseOverviewDateValue = (
  value: string | null | undefined,
): Dayjs | null => {
  if (value == null || value === "") {
    return null;
  }
  const parsed = dayjs.isDayjs(value) ? value : dayjs(String(value));
  return parsed.isValid() ? parsed : null;
};

const AnchorDataOverviewDatePicker: FC<AnchorDataOverviewDatePickerProps> = ({
  value,
  onChange,
  size = "medium",
  sx,
  className,
  inputRef,
  autoFocus,
  onBlur,
  onKeyDown,
  startAdornment,
}) => (
  <GenericDateRange
    selectionMode="single"
    value={parseOverviewDateValue(value)}
    onChange={(newValue) => {
      onChange(newValue ? newValue.format("YYYY-MM-DD") : null);
    }}
    textFieldProps={{
      fullWidth: true,
      size,
      className,
      sx,
      autoFocus,
      inputRef,
      onBlur,
      onKeyDown,
      InputProps: {
        startAdornment,
      },
    }}
  />
);

export default AnchorDataOverviewDatePicker;
